module.exports = __webpack_public_path__ + "img/map_mobile_3.042f60b8.png";